
import { defineComponent, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

import ConvertedToEmailNotice from '@/components/ConvertedToEmailNotice.vue'
import api from '@/store/api'

export default defineComponent({
  components: { ConvertedToEmailNotice },
  setup() {
    const router = useRouter()
    const data = reactive({
      handle: ''
    })
    const convertedError = ref(false)

    const formSubmitted = () => {
      api
        .call(
          'POST',
          'password_reset',
          {
            handle: data.handle
          },
          false
        )
        .then(() => {
          router.push('/legacy-login?reset-success')
        })
        .catch(error => {
          if (error?.response?.data?.converted_to_email_signin) {
            convertedError.value = true
          }
        })
    }

    const goToEmailReset = () => {
      router.push('/forgot-password-email')
    }

    const loginClicked = () => {
      router.push('/legacy-login')
    }

    return {
      formSubmitted,
      data,
      convertedError,
      goToEmailReset,
      loginClicked
    }
  }
})
